import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';

import { getContentBlockItemsByName } from '../../../Cms/CmsActions.js';

import withRouter from '../../../../components/Router/WithRouter.js';
import PredictiveLink from '../../../Cms/components/view/PredictiveLink.js';

function PanelFooterLinks({ location, navigate, panel }) {
	const handleGoTo = event => navigate(event.target.getAttribute('data-path'));

	const links = getContentBlockItemsByName(panel.blocks, 'links');
	return (
		<div className="company-info">
			{links.map((link, index) => (
				<div className="pt-2 d-inline" key={link.path}>
					{
						link.needObfuscate
							? <Button color="link" size="sm" tag="span" className="p-0 text-start" data-path={link.path} onClick={handleGoTo}>{link.text}</Button> 
							: <PredictiveLink to={link.path} href={link.path} target={link.target} className="p-0 btn-sm">{link.text}</PredictiveLink>
					}
					{index < links.length - 1 && <span className="mx-1">-</span>}
				</div>
			))}
		</div>
	);
}

PanelFooterLinks.propTypes = {
	location: PropTypes.object.isRequired,
	navigate: PropTypes.func.isRequired,
	panel: PropTypes.object.isRequired,
};

export default withRouter(PanelFooterLinks, ['navigate', 'location']);
